import React, { useEffect, useState } from 'react'
import { HTTP } from '../../../api/resources'

export default function IncreaseLimit({post, close, postCount}) {
    const [groupPost, setGroupPost] = useState(post)
    const [saving, setSaving] = useState(false)

    useEffect(() => {
        if (groupPost.limit > 1500) {
            setGroupPost({...groupPost, limit: 0})
            Alert.show('notice', 'The maximum allowed limit is 1500')
        }
    })

    const increaseLimit = async () => {
        setSaving(true)

        try {
            let response = await patchRequest()
            setSaving(false)
            Alert.show('notice', 'Limit updated successfully')
            close(response.data)
            return
        } catch {
            Alert.show('error', 'Failed to update limit, try again')
            setSaving(false)
        }
    }

    const patchRequest = () => {
        return HTTP.patch(`/group/post/limit/${groupPost.limit}`)
    }

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
                <h4>Adjust Limit</h4>

                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-group'>
                            <label htmlFor='increase_limit'>Posts Limit</label>
                            <input type='number' className='form-control' name='increase_limit' id='increase_limit' placeholder='1500' 
                                value={groupPost.limit} onChange={(event) => setGroupPost({...groupPost, limit: event.target.value})}
                            />
                            {postCount >= groupPost.limit &&
                                <small className='p-2 text-danger'>Current number of posts cannot be greater or equal to limit</small>
                            }
                        </div>
                    </div>
                </div>

                <div className="pt-3">
                    <button onClick={() => increaseLimit()} type="button" className="btn btn-primary mr-2" disabled={postCount >= groupPost.limit || saving}>
                        Update
                    </button>

                    <button onClick={() => close(null)} type="button" className="btn btn-secondary mr-2">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}
